import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { GaFormlyService, IExtraFieldConfigurationObject } from '../../shared/formly/ga-formly.service';
import { AccessDataService } from '../access-data.service';
import { GaValidateService } from '../../shared/formly/ga-validate.service';
import { TitleService } from '../../shared/services/title.service';
import { TranslationService } from '../../shared/translation/translation.service';
import { util } from '../../shared/util';

@Component({
  selector: 'forgot-password',
  template: `
    <div *ngIf="!resetLinkSent">
      <h2 class="title" translate>APP.ACCESS.FORGOT_PASSWORD</h2>

      <p translate>APP.ACCESS.PASSWORD.INSTRUCTIONS</p>
      <formly [form]="form" [fields]="fields" [model]="model" [noValidate]="true">
        <button class="btn" (click)="sendResetLink()"
          [disabled]="formInvalid" [busyButton]="sending">
          <span translate="APP.ACCESS.PASSWORD.BUTTON"></span>
        </button>
        <return-to-login class="d-inline"></return-to-login>
      </formly>
    </div>

    <div *ngIf="resetLinkSent">
      <h2 class="title" translate>APP.ACCESS.PASSWORD.EMAIL_SENT</h2>
      <p>
        <span translate>APP.ACCESS.PASSWORD.EMAIL_SENT_TO</span>
        <br>
        <span class="bold">{{ model.email }}</span>.
        <br>
        <span translate>APP.ACCESS.PASSWORD.EMAIL_SENT_CLICK_LINK</span>
      </p>
      <no-email-received></no-email-received>

      <button class="btn" uiSref="access.login">
        <span translate="APP.ACCESS.RETURN_TO_LOGIN"></span>
      </button>
    </div>
  `
})
export class ForgotPasswordComponent implements OnInit {
  public form:UntypedFormGroup = new UntypedFormGroup({});
  public fields:IExtraFieldConfigurationObject[];
  public resetLinkSent:boolean = false;
  public sending:boolean = false;
  public model:{
    email?:string;
  } = {};
  public formInvalid:boolean = true;

  constructor(
    private accessDataService:AccessDataService,
    private formlyService:GaFormlyService,
    private validateService:GaValidateService,
    titleService:TitleService,
    translationService:TranslationService
  ) {
    titleService.setTitle(translationService.instant('APP.ACCESS.FORGOT_PASSWORD'));
  }

  public ngOnInit():void {
    // create fields
    this.fields = this.createFields();

    // add listener
    this.listen();
  }

  private listen():void {
    this.form.statusChanges.subscribe(() => {
      this.formInvalid = this.form.invalid;
    });
  }

  public sendResetLink():void {
    // show form errors when the forgot password form is invalid
    this.validateService.validateFields(this.fields, this.model, true)
      .then(() => {
        this.sending = true;
        return this.accessDataService.sendPasswordResetLink(this.model.email);
      })
      .then(() => {
        this.resetLinkSent = true;
      })
      .catch(util.noop)
      .finally(() => {
        this.sending = false;
      });
  }

  private createFields():IExtraFieldConfigurationObject[] {
    return [
      this.formlyService.anInput('email', 'APP.ACCESS.PASSWORD.EMAIL_ADDRESS')
        .isRequired()
        .withLabelClass('col-sm-4')
        .withValueClass('col-sm-8')
        .withInputType('email')
        .build()
    ];
  }
}